import React, { useMemo } from 'react'
import { get } from 'lodash'

import {
  changeIndicator,
  formatDollarsWithSymbol,
  formatPercentage,
} from '../../../../utils/functions'
import FourColumnsDatapoints from '../../../FourColumnsDatapoints'
import TodaysDistribution from '../../TodaysDistribution'

const STYLE_MARGIN_TOP_48 = { marginTop: '48px' }

export default function PriceTable({ price }) {
  const firstRow = useMemo(() => {
    return [
      {
        label: 'Price (NAV)',
        value: price?.nav ? formatDollarsWithSymbol(price.nav) : '--',
        hasTodaysDistribution: !!(price?.nav && price?.todaysDistribution),
        todaysDistribution:
          price?.nav && price?.todaysDistribution ? (
            <TodaysDistribution todaysDistribution={price.todaysDistribution} />
          ) : null,
      },
      {
        label: 'NAV Daily Change ($)',
        value:
          typeof price?.navChangeDollars === 'number'
            ? formatDollarsWithSymbol(price.navChangeDollars)
            : '--',
        hasFundChangeUp:
          changeIndicator(get(price, 'navChangeDollars')) === 'fundChangeUp',
        hasFundChangeDown:
          changeIndicator(get(price, 'navChangeDollars')) === 'fundChangeDown',
      },
      {
        label: 'NAV Daily Change (%)',
        value: price?.navChangePercent
          ? formatPercentage(price.navChangePercent)
          : '--',
        hasFundChangeUp:
          changeIndicator(get(price, 'navChangePercent')) === 'fundChangeUp',
        hasFundChangeDown:
          changeIndicator(get(price, 'navChangePercent')) === 'fundChangeDown',
      },
      {
        label: 'NAV YTD Return',
        value: price?.ytdReturn ? formatPercentage(price.ytdReturn) : '--',
      },
    ]
  }, [price])

  // Memoize 'secondRow' so it only re-creates when 'price' changes
  const secondRow = useMemo(() => {
    if (!price?.etfMarketPrice) return []

    return [
      {
        label: 'Market Price',
        value: price.etfMarketPrice.marketPrice
          ? formatDollarsWithSymbol(price.etfMarketPrice.marketPrice)
          : '--',
      },
      {
        label: 'Market Daily Change ($)',
        value:
          typeof price.etfMarketPrice.changeDollars === 'number'
            ? formatDollarsWithSymbol(price.etfMarketPrice.changeDollars)
            : '--',
        hasFundChangeUp:
          changeIndicator(get(price, 'etfMarketPrice.changeDollars')) ===
          'fundChangeUp',
        hasFundChangeDown:
          changeIndicator(get(price, 'etfMarketPrice.changeDollars')) ===
          'fundChangeDown',
      },
      {
        label: 'Market Daily Change (%)',
        value: price.etfMarketPrice.changePercent
          ? formatPercentage(price.etfMarketPrice.changePercent)
          : '--',
        hasFundChangeUp:
          changeIndicator(get(price, 'etfMarketPrice.changePercent')) ===
          'fundChangeUp',
        hasFundChangeDown:
          changeIndicator(get(price, 'etfMarketPrice.changePercent')) ===
          'fundChangeDown',
      },
      {
        label: 'Market YTD Return',
        value: price.etfMarketPrice.ytdReturn
          ? formatPercentage(price.etfMarketPrice.ytdReturn)
          : '--',
      },
    ]
  }, [price])

  return (
    <div>
      <FourColumnsDatapoints datapoints={firstRow} />
      {secondRow.length > 0 && (
        <FourColumnsDatapoints
          datapoints={secondRow}
          style={STYLE_MARGIN_TOP_48}
        />
      )}
    </div>
  )
}